import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";

// Custom.
import Layout from "containers/Layout/Layout";
import { Form } from "@vocollege/components";
import I18n from "@vocollege/app/dist/modules/Services/I18n";
import {
  GET_SECTION,
  UPDATE_SECTION,
  CREATE_SECTION,
} from "@vocollege/app/dist/modules/VoApi/graphql";
import { VoAuth } from "@vocollege/app";
import Utils from "services/Utils";

export default function SectionEdit() {
  const router = useParams<any>();
  const navigate = useNavigate();

  // Methods.

  const getInitialState = () => {
    const initialState: { [Key: string]: any } = {
      id: 0,
      title: "",
      body: "",
      status: 0,
      author: null,
      template: "default_left",
      image_full: 1,
      images: [],
    };
    const { id } = router;
    if (id && id === "create") {
      initialState.author = {
        id: VoAuth.currentUser.id,
        name: VoAuth.currentUser.name,
        type: "user",
      };
    }
    return initialState;
  };

  const getAvailableTemplateValues = () => {
    return Object.keys(I18n.get.section.templates).map((template: string) => ({
      label: I18n.get.section.templates[template],
      value: template,
    }));
  };

  const handleRedirect = (state: any) => {
    if (Utils.redirect(state)) {
      toast.info(I18n.get.form.messages.redirecting, { autoClose: 0 });
    } else {
      navigate("/content/sections");
    }
  };

  return (
    <Layout>
      <Form
        tabs={[
          {
            key: "content",
            label: I18n.get.misc.content,
            fields: [
              {
                name: "title",
                label: I18n.get.form.labels.title,
                type: "text",
                required: true,
                grid: {
                  xs: 12,
                  md: 9,
                },
                validation: {
                  required: true,
                },
              },
              {
                name: "status",
                label: I18n.get.status.published,
                type: "switch",
                required: true,
                grid: {
                  xs: 12,
                  md: 3,
                },
              },
              {
                name: "images",
                label: I18n.get.misc.image,
                type: "file_field",
                grid: {
                  xs: 12,
                  md: 9,
                },
                params: {
                  filetypes: ["image"],
                  multiple: false,
                },
              },
              {
                name: "image_full",
                label: I18n.get.section.labels.imageFull,
                type: "switch",
                required: true,
                grid: {
                  xs: 12,
                  md: 3,
                },
              },
              {
                name: "author",
                label: I18n.get.misc.author,
                type: "entity_field",
                grid: {
                  xs: 12,
                  md: 7,
                },
                params: {
                  dialog: {
                    types: ["user"],
                  },
                  fields: {
                    user: {
                      title: "name",
                    },
                  },
                },
              },
              {
                name: "template",
                label: I18n.get.form.labels.template,
                type: "select",
                required: true,
                grid: {
                  xs: 12,
                  md: 5,
                },
                validation: {
                  required: true,
                },
                params: {
                  availableValues: getAvailableTemplateValues,
                },
                // onChange: handleCategoryChange,
              },
              {
                name: "body",
                label: I18n.get.form.labels.body,
                type: "editor",
                required: false,
                grid: {
                  xs: 12,
                },
              },
            ],
          },
        ]}
        labels={{
          loading: I18n.get.form.labels.loadingContent,
          create: I18n.get.section.labels.createSection,
          created: I18n.get.section.messages.sectionSaved,
          updated: I18n.get.section.messages.sectionSaved,
          deleted: I18n.get.section.messages.sectionDeleted,
          fieldRequired: I18n.get.form.errors.required,
        }}
        operations={{
          category: "section",
          get: GET_SECTION,
          create: CREATE_SECTION,
          update: UPDATE_SECTION,
        }}
        // paths={{
        //   back: "/content/sections",
        // }}
        initialState={getInitialState()}
        pageTitleField="title"
        classes={{
          paper: "vo-global__content-with-toolbar",
          toolbar: "vo-global__content-toolbar",
        }}
        onComplete={handleRedirect}
        onCancel={handleRedirect}
      />
    </Layout>
  );
}
